module.exports = __webpack_public_path__ + "static/media/btn_now.8bb69751.png";